import React from 'react';
import {Button, Flex, Spacer, Text, useToast} from '@chakra-ui/react';
import {useIntentModelFromContext} from './IntentModelProvider';
import {useIntentModelStore} from './IntentModeStore';
import {IntentModelTabs} from './IntentModelTabs';

export const IntentModelHeader = () => {
  const intentModel = useIntentModelFromContext();
  const {saveIntentModel} = useIntentModelStore();
  const toast = useToast();

  const handleSave = () => {
    saveIntentModel.mutate(undefined, {
      onSuccess: () => {
        toast({
          title: 'Intent model saved',
          status: 'success',
          duration: 2_000,
        });
      },
    });
  };

  return (
    <Flex
      alignItems="center"
      borderBottom="1px solid"
      borderColor="kgray.200"
      justifyContent="space-between"
      gap="4"
      p="6"
    >
      <Text fontSize="2xl" fontWeight="500">
        {intentModel.label}
      </Text>
      <IntentModelTabs />
      <Spacer />
      <Button
        colorScheme="kbuttonblue"
        onClick={handleSave}
        isLoading={saveIntentModel.isPending}
        px="6"
      >
        Save
      </Button>
    </Flex>
  );
};
